/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { canEditItemForItem, getId } from '../../utils/item';
import { update } from '../../services/item';
import { isTouchOnlyContext } from '../../utils/inputCapabilities';
import { isEditable } from '../../utils/roles';
import { NumSortable } from './num.Sortable';

export const NumAll = props => {
  const { itemId } = props;

  const item = useSelector(state => state.items[itemId]);
  const items = useSelector(state => state.items);
  const isModalOpen = useSelector(state => state.global.openModales);
  const isMobile = useSelector(state => state.global.isMobile);
  const isTouch = useSelector(state => state.global.isTouch);
  const [nums, setNums] = useState(item?.has_num ?? []);
  const canEdit = canEditItemForItem(item, items);
  const touchLocked = isTouchOnlyContext(isTouch);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    })
  );

  const handleDragEnd = event => {
    const { active, over } = event;
    if (active?.id && over?.id && active.id !== over.id) {
      setNums(prev => {
        const oldIndex = prev.findIndex(numObj => getId(numObj) === active.id);
        const newIndex = prev.findIndex(numObj => getId(numObj) === over.id);
        return arrayMove(prev, oldIndex, newIndex);
      });
    }
  };

  useEffect(() => {
    if (item?.has_num) {
      setNums(item.has_num);
    } else {
      setNums([]);
    }
  }, [item?.has_num]);

  useEffect(() => {
    if (
      Array.isArray(nums) &&
      Array.isArray(item?.has_num) &&
      nums.length === item.has_num.length &&
      JSON.stringify(nums) !== JSON.stringify(item.has_num)
    ) {
      update(`items/${itemId}`, 'has_num', nums);
    }
  }, [nums]);

  return (
    <div className='h-full w-full flex-1'>
      {nums?.length > 0 && (
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext
            items={nums.map(numObj => getId(numObj))}
            strategy={verticalListSortingStrategy}
            disabled={
              isEditable() === false ||
              isEditable(Object.values(isModalOpen).includes(true)) ||
              isMobile ||
              touchLocked ||
              !canEdit
            }
          >
            {nums.map(numObj => (
              <NumSortable
                key={getId(numObj)}
                id={getId(numObj)}
                numId={getId(numObj)}
                itemId={itemId}
              />
            ))}
          </SortableContext>
        </DndContext>
      )}
    </div>
  );
};
